import { z } from 'zod';
import { commonIdNumberInputSchema } from 'schemas/number.schema';
import type { TestInstanceResponseInputType } from 'services/assist-api/entities/test-instance-response/types';

/**
 * Schema used by the Marker Dashboard and Marking Allocation tab filter forms.
 */
export const dashboardAndAllocationFilterFormSchema = z.object({
  testIds: z.array(z.number()),
  modes: z.array(z.custom<TestInstanceResponseInputType>())
});
export const dashboardAndAllocationFilterFormDefaultValues = {
  testIds: [],
  modes: []
};

/**
 * Schema used by the NSN filter across various filter forms.
 */
export const nsnFilterSchema = z.object({ nsn: z.string() });
export const nsnFilterDefaultValue = { nsn: '' };

/** Schema used by the Response ID filter used across various filter forms. */
export const responseIdFilterSchema = z.object({ responseId: commonIdNumberInputSchema });
export const responseIdFilterDefaultValue = { responseId: '' };

/**
 * Schema used by the Mark ID filter used across various filter forms.
 */
export const markIdFilterSchema = z.object({ markId: commonIdNumberInputSchema });
export const markIdFilterDefaultValue = { markId: '' };

/**
 * Schema used by the Marker filter across various filter forms.
 */
export const markerFilterSchema = z.object({
  markerOrganisationUserIds: z.array(z.number()) // The organisation user ID of the marker.
});
export const markerFilterDefaultValue = { markerOrganisationUserIds: [] };
